import Tag from './tag';
export type { TTagSize, TTagVariant, TagProps } from './tag.types';

export default Tag;
